'use client';
import * as React from 'react';
const messageBarContext = React.createContext(undefined);
export const messageBarContextDefaultValue = {
    titleId: '',
    layout: 'singleline',
    actionsRef: React.createRef(),
    bodyRef: React.createRef()
};
export const MessageBarContextProvider = messageBarContext.Provider;
export const useMessageBarContext = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(messageBarContext)) !== null && _React_useContext !== void 0 ? _React_useContext : messageBarContextDefaultValue;
};
